var map = {
	"./page-01.jpg": 8887,
	"./page-02.jpg": 5080,
	"./page-03.jpg": 2949,
	"./page-04.jpg": 6830,
	"./page-05.jpg": 4875,
	"./page-06.jpg": 2892,
	"./page-07.jpg": 7593,
	"./page-08.jpg": 9554,
	"./page-09.jpg": 1263,
	"./page-10.jpg": 7473,
	"./page-11.jpg": 9428,
	"./page-12.jpg": 1059,
	"./page-13.jpg": 7894,
	"./page-14.jpg": 9357,
	"./page-15.jpg": 128,
	"./page-16.jpg": 7391,
	"./page-17.jpg": 9458,
	"./page-18.jpg": 8169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5489;